<template>
  <div class="weui-search-box">
    <div class="weui-cell weui-cell_active" :class="{'weui-required':required}">
      <div class="weui-cell__hd" v-if="label">
        <label for class="weui-label">{{label}}</label>
      </div>
      <div class="weui-cell__bd">
        <input
          v-model="keyword"
          class="weui-input weui-search-box__input"
          :placeholder="placeholder"
          ref="input"
        />
      </div>
    </div>
    <div class="weui-cells weui-search-result" v-if="result && result.length">
      <div
        class="weui-cell weui-cell_active weui-cell_access"
        v-for="(item, index) in result"
        :key="item.key"
        @click="onSelect(index)"
      >
        <div class="weui-cell__bd weui-cell_primary">
          <p>{{ item.name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    placeholder: {
      type: String,
      default: "搜索",
    },
    value: String,
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      keyword: null,
      result: [],
    };
  },
  watch: {
    keyword(val) {
      if (val) {
        if (this.$refs.input == document.activeElement) {
          this.search(val);
          this.$emit("input", val);
          this.$emit("change");
        }
      } else {
        this.resetResultList();
      }
    },
  },
  methods: {
    resetResultList() {
      this.result = [];
    },
    search() {
      var me = this;
      setTimeout(function () {
        if (!me.searching && me.keyword && me.keyword.length > 1) {
          me.searching = true;
          me.$ajax({
            url: "/api/account/company/qcc_search",
            params: {
              keyword: me.keyword
            }
          })
            .then(function (res) {
              me.searching = false;
              me.result = res.data.map(item => {
                item.key = item.creditCode + item.no;
                return item;
              });
            })
            .catch(function () {
              me.searching = false;
            });
        }
      }, 100);
    },
    onSelect(index) {
      var me = this,
        selected = me.result[index];
      me.$refs.input.blur();
      me.keyword = selected.name;
      me.$emit("input", selected.name);
      me.$emit("select", selected);
      me.resetResultList();
    },
  },
};
</script>

<style scoped>
.weui-search-result {
  background-color: #f8f8f8;
  max-height: 300px;
  overflow-y: auto;
}
.weui-search-box {
  position: relative;
}
.weui-search-box:before {
  content: " ";
  position: absolute;
  top: 0;
  left: 32px;
  right: 32px;
  height: 1px;
  color: rgba(0, 0, 0, 0.1);
  color: var(--weui-FG-3);
  z-index: 2;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  border-top: 1px solid var(--weui-FG-3);
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}
.weui-cells {
  background-color: var(--weui-BG-1);
}
</style>